import { setupMobileMenu } from "./js/mobile.js";
import { scrollPhoto } from "./js/scroll.js";
import { dollar } from "./js/dollar.js";
import { initSwiper } from "./js/swiper.js";
import { paralaks } from "./js/paralaks.js";
import { simple } from "./js/simplelightbox.js";
import { alertShow } from "./js/showAlert.js";
import { video } from "./js/video.js";


scrollPhoto();
setupMobileMenu();
dollar();
initSwiper();
paralaks();
simple();
alertShow();
video();


